import { Reveal } from "./Reveal";

export function SectionLabel({ index, children }) {
  return (
    <div className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
      <span className="h-px w-8 bg-brand" />
      {children}
    </div>
  );
}

export function PageHeader({ label, kicker = "Overview", title, intro }) {
  return (
    <section className="relative border-b border-border pt-36 pb-16 sm:pt-44 sm:pb-24">
      <div className="tech-grid pointer-events-none absolute inset-0 opacity-30 mask-fade-b" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionLabel index={label}>{kicker}</SectionLabel>
        <Reveal>
          <h1 className="mt-8 max-w-4xl font-display text-5xl font-light leading-[0.95] tracking-tighter sm:text-7xl">
            {title}
          </h1>
        </Reveal>
        {intro && (
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-muted-foreground">{intro}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
